import React from "react";
import RenewPasswordForm from "~/components/Forms/RenewPasswordForm";

const RenewPasswordPage: React.FC = () => {
    return <React.Fragment>
        <RenewPasswordForm/>
    </React.Fragment>
}

export default RenewPasswordPage;